import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Base} from '../../common/model/base.model';
import {TipoGerarchia} from '../tipogerarchia/tipogerarchia.model';
import {TipoEntitaOrganizzativa} from '../tipoentitaorganizzativa/tipoentitaorganizzativa.model';

export class TipoGerarchiaStruttura extends Base {

  constructor(protected id: number,
              public tipoGerarchia: TipoGerarchia,
              public padre: TipoEntitaOrganizzativa,
              public figlio: TipoEntitaOrganizzativa,
              public modifica: boolean,
              public ordine: number) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'tipoGerarchia', 'padre', 'figlio', 'modifica', 'ordine'];
  }

  public getLabel() {
    const padreLabel = this.padre ? this.padre.getLabel() : 'ROOT';
    return this.tipoGerarchia.getLabel() + ' - ' + padreLabel + ' - ' + this.figlio.getLabel();
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('tipoGerarchia', new TableRowValue(this.tipoGerarchia.getLabel(), null));
    rowValues.set('padre', new TableRowValue(this.padre ? this.padre.getLabel() : null, null));
    rowValues.set('figlio', new TableRowValue(this.figlio.getLabel(), null));
    rowValues.set('modifica', new TableRowValue(this.modifica, null));
    rowValues.set('ordine', new TableRowValue(this.ordine, null));
    return new TableRow(this, rowValues);
  }
}
